import { DarkBox } from '@dispatch/web/ui';
import { SignupRedirect } from '@dispatch/web/auth';

/**
 * Signup Redirect Page
 * Wrapper page that provides the dark background for the SignupRedirect component
 * Handles the /signup-redirect route after B2C signup
 */
export function SignupRedirectPage() {
  return (
    <DarkBox
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <SignupRedirect />
    </DarkBox>
  );
}

export default SignupRedirectPage;
